import { gql } from '@apollo/client';
import {
  ActivityFragment,
  LandingFragment,
  LinkFragment,
  SourceFragment,
  ServiceFragment,
  FontsFragment,
} from './fragments';

export default gql`
  ${SourceFragment}
  ${ActivityFragment}
  ${LinkFragment}
  ${LandingFragment}
  ${ServiceFragment}
  ${FontsFragment}
  query Client($shortName: String!, $locale: String!) {
    clientCollection(
      where: { shortName: $shortName }
      limit: 1
      locale: $locale
    ) {
      items {
        sys {
          id
        }
        assessmentInCrisis {
          json
        }
        name
        slug
        url
        sector
        shortName
        formalShortName
        logoReverse {
          url
        }
        colors
        userRatingCutoff
        expertRatingCutoff
        averageRatingCutoff
        signIn
        msOAuthSignIn
        googleSignIn
        facebookSignIn
        cmSignIn
        samlSignIn
        samlLabel
        samlProviderId
        metadata
        aicc
        crediblemindLogo {
          url
        }
        clientParentCollection {
          items {
            title
          }
        }
        excludeTopicCollection {
          items {
            title
            slug
            reviewStatus
            type
            description
            sys {
              id
            }
            image {
              url
            }
          }
        }
        excludeAssessmentCollection {
          items {
            title
            name
            slug
            sys {
              id
            }
          }
        }
        landingLinksCollection {
          items {
            title
            slug
            menuTitle
            menuImage {
              url
            }
            showMenu
            menuOrder
          }
        }
        landingMenuCollection {
          items {
            ...LandingFields
          }
        }
        clientResourcesCollection {
          items {
            ...ClientSourceFields
            ...ClientActivityFields
            ...ClientServiceFields
          }
        }
        inCrisisResourcesCollection {
          items {
            ...ClientSourceFields
            ...ClientActivityFields
            ...ClientLinkFields
          }
        }
        context
        footer {
          json
        }
        languageCollection {
          items {
            slug
            title
            shortcode
            image {
              url
            }
          }
        }
        customFontsCollection {
          items {
            ...FontsFields
          }
        }
        clientConfigured
        contact {
          name
          role
          email
          phone
          image {
            url
          }
          calendar
        }
        report
        formalShortName
        locationCollection {
          items {
            location {
              lat
              lon
            }
            city
            state
          }
        }
        languageDisclaimer {
          json
        }
      }
    }
  }
`;
